import { apiGet, apiGetAll, apiPost, apiPut, apiDelete } from '@ibkr/clientportal.common/src/api/default'

const base = '/iserver';

function getOrderStatus(orderId) {
    return apiGet(base + '/account/order/status/' + orderId);
}

function getOrderStatusAndRules(orderId, conid, isBuy) {
    let rules = `/iserver/contract/${conid}/rules?isBuy=${isBuy}`
    let status = `/iserver/account/order/status/${orderId}`
    return apiGetAll([rules, status]);
}

function getSecondaryOrderRules(conid, isBuy, limitPrice) {
    return apiGet(base + `/contract/${conid}/rules?isBuy=${isBuy}&hasSecondary=true&limitPrice=${limitPrice}`);
}

function getPriceHistory(conid, period, format, source, bar, outsideRth, startTime, direction) {
    const conidObj = { conid, period, format, source, bar, outsideRth, startTime, direction };
    const endPoint = createHistoryEndpoint(conidObj);
    if (endPoint) {
        return apiGet(endPoint);
    }
}

function getPriceHistoryAll(conidObjArr = []) {
    let endPoints = [];
    if (conidObjArr.length > 0) {
        conidObjArr.forEach(conidObj => {
            const endPoint = createHistoryEndpoint(conidObj);
            if (endPoint) {
                endPoints.push(endPoint);
            }
        });
    }
    if (endPoints.length > 0) {
        return apiGetAll(endPoints);
    }
}

function createHistoryEndpoint(conidObj) {
    const { conid, period = '1w', format = '', source = '', bar = '', outsideRth = false, startTime, direction } = conidObj;
    if (isNaN(conid)) {
        return;
    }
    let append = '&period=' + period
    if (format != '') {
        append += '&format=' + format
    }
    if (source != '') {
        append += '&source=' + source
    }
    if (bar != '') {
        append += '&bar=' + bar
    }
    if (startTime) {
        append += '&startTime=' + startTime
    }
    if (direction) {
        append += '&direction=' + direction
    }
    append += '&outsideRth=' + outsideRth;
    return base + '/marketdata/history?conid=' + conid + append;
}

function getEstimatedProbability(conidex, price) {
    return apiPost(base + '/estimatedprobability', { conidex, price });

}

function getEstimatedPrice(conidex) {
    return apiPost(base + '/estimatedprice', { conidex });
}

function getAccounts() {
    return apiGet(base + '/accounts');
}

function closeAllPositions(order) {
    return apiPost(base + '/positions/closeall', order);
}

function compete() {
    return apiPost(base + '/auth/compete');
}

function getLinks(types) {
    return apiGet(base + '/links?types=' + types);
}

function getPnl(acctId) {
    return apiGet(base + '/account/pnl/partitioned');
}

function getOrders(force) {
    return apiGet(`${base}/account/orders?force=${force ? true : false}`);
}

function getBulletins() {
    return apiGet(base + '/bulletins');
}

function replyNotification(data) {
    return apiPost(base + '/notification', data);
}

function status() {
    return apiPost(base + '/auth/status');
}

function autologon() {
    return apiPost(base + '/auth/autologon');
}

function logout() {
    return apiPost(base + '/auth/logout');
}

function tickleSession() {
    return new Promise(); // disable for now CLNTPORTAL-1065
    //return apiGet(base + '/auth/tickle');
}

function ssoDHresponse(response) {
    return apiPost(base + '/auth/ssodh/response', { response: response });
}

function ssoDHinit(username, compete = false, useSecurityContext = false, locale) {
    const tz = `xxx (${$date.data.timeZone})` || '';
    return apiPost(base + '/auth/ssodh/init', { username, compete, useSecurityContext, locale, tz });
}

function setClientStatus(id, value) {
    return apiPost(base + '/status/update', { id, value });
}

//DEPRECATED
const addRealtimeListener = ( { onUpdates, onError, onSubscribed }) => {
    if (!window.ibrt) {
        console.error('iserver: add rt real-time api missing');
        return;
    }
    if (window.ibrt.isSubscribed('realtime-data')) {
        console.warn('already subscribed to realtime-data');
        return;
    }
    return window.ibrt.subscribe('realtime-data', 'RD', {
            'onMessage': onUpdates,
            'onSubscribed': onSubscribed,
            'onError': onError
        });
}

//DEPRECATED
const subscribeIserverUpdates = ( { acctId },  { onUpdates, onError, onSubscribed }) => {
    if (!window.ibrt) {
        console.error('iserver: subscribe real-time api missing');
        return;
    }
    if (window.ibrt.isSubscribed('realtime-account-data+' + acctId)) {
        console.warn('already subscribed to realtime-account-data');
        return;
    }
    return window.ibrt.subscribe('realtime-account-data+' + acctId, 'RAD', {
            'onMessage': onUpdates,
            'onSubscribed': onSubscribed,
            'onError': onError
        });
}

// DEPRECATED
const unsubscribeIserverUpdates = ({ acctId }) => {
    if (!window.ibrt) {
        console.error('iserver: unsubscribe real-time api missing');
        return;
    }
    window.ibrt.cancelAll('realtime-account-data+' + acctId);
}

function getBriefingArticle() {
    return apiGet(base + '/news/briefing');
}

function setAccount(acct) {
    return apiPost(base + '/account', { acctId: acct });
}

function setOEMode(conid, isUnsubscribe) {
    return apiPost(base + '/orderentrymode', { conid: conid, isUnsubscribe: isUnsubscribe });
}

function searchBySym(sym, secType='STK', referrer='') {
    return apiPost(base + '/secdef/search', {'symbol': sym, 'name': false, 'secType': secType, 'referrer': referrer});
}

function getRegsnapshot(conid) {
    return apiGet(base + '/marketdata/regsnapshot?conid=' + conid + '&fields=31,84,85,86,88,7057,7058,7059,7067,7068' );
}

function getDebugPnl({ conid, account = '', type }) {
    return apiPost(base + '/account/debugpnl', {'conid': conid, 'account': account, 'type': type });
}

function getCurrencyPairs(currency) {
    return apiGet(base + `/currency/pairs?currency=${currency}`);
}

function getContractInfo(conid) {
    return apiGet(base + `/contract/${conid}/info`);
}

function getOrderRules(data) {
    return apiPost(base + '/contract/rules', data);
}

function getTrades() {
    return apiGet(base + '/account/trades');
}

function getAllWatchlists({SC}) {
console.debug('SC', SC);
    return apiGet(base + '/watchlists' + (SC !== undefined ? "?SC="+ SC : ""));
}

// expecting wl object with wl.id, wl.name and wl.rows
function saveWatchlist(wl) {
    return apiPost(base + '/watchlist', wl);
}

function getWatchlist(id) {
    return apiGet(base + '/watchlist?id=' + id);
}

function deleteWatchlist(id) {
    return apiDelete(base + '/watchlist?id=' + id);
}

function getPFMDColumns(data) {
    return apiGet(base + '/marketdata/columns/pf?SELECTED=' + data);
}

function getWLMDColumns(data) {
    return apiGet(base + '/marketdata/columns/wl?SELECTED=' + data);
}

function getMDColumns(data) {
    return apiPost(base + '/marketdata/columns', data);
}

function getScannerParams() {
    return apiGet(base + '/scanner/params');
}

function getUserWatchLists() {
    return apiGet('/lists');
}

function postScannerQuery(instrument, type, filter, location, size) {
    return apiPost(base + '/scanner/run', { instrument, type, filter, location, size});
}

//- Alerts APIs

//- create or modify an alert
function createOrModifyAlert(accountId, body) {
    return apiPost(`${base}/account/${accountId}/alert`, body);
}

//- get all available alerts
function getAvailableAlerts(accountId) {
    return apiGet(`${base}/account/${accountId}/alerts`);
}

//- activate or deactivate an alert
function activateAlert(accountId, params) {
    return apiPost(`${base}/account/${accountId}/alert/activate`, params);
}

//- delete an alert
function deleteAlert(accountId, alertId) {
    return apiDelete(`${base}/account/${accountId}/alert/${alertId}`);
}

//--get alert details
function getAlertDetails(id) {
    return apiGet(`${base}/account/alert/${id}?type=Q`);
}

//--get mta alert
function getMtaAlert() {
    return apiGet(`${base}/account/mta`);
}

function getComboLegs(conid) {
    return apiPost(`${base}/combo/legs`, { conid });
}

//-- Folio/Sleeves api

//- get models
function getFolioModels({ selectedAcctId }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'getModels',
        account: selectedAcctId
    });
}

//- get model details
function getFolioModel({ selectedAcctId, modelName }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'getModel',
        account: selectedAcctId,
        modelName: modelName
    });
}

//- get model orders
function getFolioModelOrders({ selectedAcctId, modelName }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'getModelOrdersStatus',
        account: selectedAcctId,
        modelName: modelName
    });
}

//- create/update model with targets
function createUpdateFolioModel({ selectedAcctId, modelEntry, targetList }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'createOrUpdateModelWithTargets',
        account: selectedAcctId,
        modelEntry: modelEntry,
        targetList: targetList
    });
}

//- rebalance order
function rebalanceFolioModel({ selectedAcctId, modelName, amount, fullDivest }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'computeInvestDivestRebalanceOrders',
        account: selectedAcctId,
        amount: amount,
        fullDivest: fullDivest,
        modelName: modelName
    });
}

//- trasnmit folio order
function transmitFolioOrders({ investDivestRebalanceSetID, overrideList, waitSeconds }) {
    return apiPost(`${base}/sleeve`, {
        requestType: 'transmitOrdersAndTransfers',
        investDivestRebalanceSetID: investDivestRebalanceSetID,
        overrideList: overrideList,
        waitSeconds: waitSeconds
    });
}

function getCryptoClarification(type, origin, time, tif, isBuy=true, conid, orderType) {
    let url = `${base}/crypto/clarification?type=${type}&origin=${origin}`;
    if (time !== undefined) {
        url += `&time=${time}`;
    }
    if (isBuy !== undefined) {
        url += `&isBuy=${isBuy}`;
    }
    if (tif != undefined) {
        url += `&tif=${tif}&conid=${conid}&orderType=${orderType}`;
    }
    return apiGet(url);
}

export default {
    getOrderStatus,
    getOrderStatusAndRules,
    getSecondaryOrderRules,
    getPriceHistory,
    getPriceHistoryAll,
    getEstimatedProbability,
    getEstimatedPrice,
    addRealtimeListener,
    closeAllPositions,
    getPnl,
    getAccounts,
    compete,
    getLinks,
    unsubscribeIserverUpdates,
    subscribeIserverUpdates,
    getOrders,
    status,
    autologon,
    logout,
    ssoDHinit,
    ssoDHresponse,
    setClientStatus,
    tickleSession,
    getBulletins,
    getBriefingArticle,
    setAccount,
    setOEMode,
    searchBySym,
    replyNotification,
    getRegsnapshot,
    getDebugPnl,
    getCurrencyPairs,
    getContractInfo,
    getOrderRules,
    getTrades,
    getWatchlist,
    deleteWatchlist,
    getAllWatchlists,
    getMDColumns,
    getPFMDColumns,
    getWLMDColumns,
    getScannerParams,
    getUserWatchLists,
    saveWatchlist,
    postScannerQuery,
    createOrModifyAlert,
    getAvailableAlerts,
    activateAlert,
    deleteAlert,
    getAlertDetails,
    getMtaAlert,
    getComboLegs,
    getFolioModels,
    getFolioModel,
    getFolioModelOrders,
    createUpdateFolioModel,
    rebalanceFolioModel,
    transmitFolioOrders,
    getCryptoClarification
}
